import 'sass/blocks/personal-data-view.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import { ProfileStep1 } from 'components/newAccountSteps/profileSteps/ProfileStep1/ProfileStep1';
import { errorTag } from 'utilities/uTagging';
import { PATH_CONTACT, PATH_ERROR } from 'constants/uTagConstants/paths';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { PUBLICA_URL } from 'constants';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { formatText, FormattedText } from 'core/i18n';
import Storage from 'utilities/storage';
import preLoaderActions from 'actions/preLoaderActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import UtagHelper from 'utilities/utagHelper';
import cryptoJS from 'crypto-js';
import { getGA4EventKeys } from 'utilities/ga4';

class PersonalDataView extends React.Component {
    constructor(props) {
        super(props);

        this.getBatchMessages = this.getBatchMessages.bind(this);
        this.getBatchError = this.getBatchError.bind(this);
    }

    componentDidMount() {
        const { userProfile, products, immStepsState, recordAndSavePage } = this.props;
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        !immStepsState.get('welcomeCard') &&
            recordAndSavePage(
                PATH_CONTACT,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                JointHolderInfo,
                '',
                '',
                userProfile.investmentType,

                {
                    ...getGA4EventKeys({
                        eventName: 'step_personal_data',
                        pageName: '/onboarding/step2/personalData',
                        processDetail: 'personalData',
                        onboardingType: userProfile.investmentType,
                    }),
                    devId: '1personalDataView',
                    identificadorOnboarding: docNumberEncrypted,
                    processStep: 'step2',
                }
            );
    }

    getBatchError() {
        return this.props.errorState.batchError;
    }

    getBatchMessages() {
        const { preLoaderActions } = this.props;
        preLoaderActions.hidePreLoader();
        errorTag('', PATH_ERROR);

        return (
            <MessagesScreen
                iconClass="icons icons--icon-clock-type-2"
                title={formatText('messagesScreen-batchErrorTitle')}
                subtitle={formatText('messagesScreen-batchErrorSubTitle')}
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={function () {
                    Storage.cookies.remove('accessToken');
                    Storage.cookies.remove('refreshToken');
                    window.location.href = PUBLICA_URL;
                }}
            >
                <FormattedText value="messagesScreen-batchErrorContent" />
                <FormattedText value="messagesScreen-batchErrorContent2" />
                <FormattedText value="messagesScreen-customerServiceDepartment" />
            </MessagesScreen>
        );
    }

    renderProfileOrError() {
        const batch = this.getBatchError();
        if (batch) {
            return <div className="profesional-data-view">{this.getBatchMessages()}</div>;
        }

        return (
            <div className="personal-data-view">
                <ProfileStep1 />
                <WelcomeCard />
            </div>
        );
    }

    render() {
        return this.renderProfileOrError();
    }
}

module.exports.constructor = PersonalDataView;
module.exports.PersonalDataView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        errorState: state.error,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(PersonalDataView);
